import { ChangeDetectionStrategy, Component, computed, CUSTOM_ELEMENTS_SCHEMA, effect, ElementRef, inject, QueryList, signal, viewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StepsNavigationMapService } from '../../services/steps-navigation.service';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';
import { IndicationComponent } from '../indication/indication.component';
import { Transfers } from 'src/app/pages/custom-route/interfaces/custom-route.interface';

@Component({
    selector: 'indications-list',
    standalone: true,
    imports: [ 
        CommonModule,
        TranslateModule,
        IndicationComponent,
        DragHandleComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './indications-list.component.html',
    styleUrl: './indications-list.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})

export class IndicationsListComponent {
    public indicationsListRef = viewChild<ElementRef>('indicationsListRef');
    @ViewChildren("itemElements") itemElements!: QueryList<ElementRef>;

    private _stepNavigationService: StepsNavigationMapService = inject(StepsNavigationMapService);
    private _bottomSheet: MatBottomSheet = inject(MatBottomSheet);
    private _bottomSheetData: any = inject(MAT_BOTTOM_SHEET_DATA, { optional: true });
    private _dialogData: any = inject(MAT_DIALOG_DATA, { optional: true });

    public currentStepIndex = computed<number>(() => this._stepNavigationService.currentStepIndex());
    public transfers = signal<Transfers[]>([]);

    private currentStepTest = effect(() => {
      const bottomSheetContainer = document.querySelector('mat-bottom-sheet-container');
      const activeItem: ElementRef = this.itemElements.toArray()?.[this.currentStepIndex()];
      if (activeItem && bottomSheetContainer){
        const offsetTop = activeItem.nativeElement.offsetTop;
        const padding = 4; 

        bottomSheetContainer.scrollTo({
          top: offsetTop - padding,
          behavior: 'smooth'
        });
      }
    })
    
    ngOnInit(): void{
        const data: Transfers[] = this._dialogData?.transfers ?? this._bottomSheetData?.transfers
        this.transfers.set(data);
    }

    public getProgress(index: number): number{
        return Math.round((index / this.transfers()?.length) * 100); 
    }
    
    public getSign(index: number): string | null {
        return this.transfers()?.[index]?.mode === 'walking'
         ? this.transfers()?.[index]?.iconName ?? null
         : this.transfers()?.[index]?.mode?.toLowerCase() ?? null
    }

    public getTimeRemaining(duration: number): number{
        return Math.ceil(duration / 60);
    }

    public fromPointPlannerCustomRouteMobile(): boolean {
      return this._bottomSheetData?.fromPointPlannerCustomRouteMobile || false;
    }
    
    public fromPointPlannerCustomRouteDesktop(): boolean {
      return this._bottomSheetData?.fromPointPlannerCustomRouteDesktop || false;
    }

    public closeBottomSheet(): void {
      this._bottomSheet.dismiss();
    }

}